import { render, staticRenderFns } from "./ShoppingListV1.vue?vue&type=template&id=317bfd5f&scoped=true&"
import script from "./ShoppingListV1.vue?vue&type=script&lang=js&"
export * from "./ShoppingListV1.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingListV1.vue?vue&type=style&index=0&id=317bfd5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317bfd5f",
  null
  
)

export default component.exports